var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',{class:{ show: _vm.showButton },attrs:{"type":"primary","round":""},on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"tim-icons icon-up-arrow"})])
}
var staticRenderFns = []

export { render, staticRenderFns }